/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {ModelComponent as ɵa} from './lib/components/model/model.component';